<template>
  <div v-loading="loading" class="yz-table">
    <el-table v-bind="$attrs" :data="innerData" style="width: 100%" fit :stripe="stripe" :max-height="maxHeight"
      :header-cell-style="headerStyle" v-on="$listeners" @sort-change="sorting" @selection-change="selectionChange">
      <template v-for="(item, index) in innerColumn">
        <el-table-column v-if="item.type == 'selection' || item.type == 'index'" :key="index + 'selection'" :label="item.label" :type="item.type"
          :width="item.width" :min-width="item.minWidth" :class-name="item.class" :label-class-name="item.labelClass"
          :sortable="item.sort ? item.sort : false" />
        <el-table-column v-else :key="index" :label="item.label" :type="item.type" :width="item.width"
          :min-width="item.minWidth" :class-name="item.class" :label-class-name="item.labelClass"
          :sortable="item.sort ? item.sort : false">
          <template slot="header">
            <slot v-if="item.renderHeader" name="customHeader" />
            <span v-else>{{ item.label }}</span>
          </template>
          <template slot-scope="{ row }">
            <div v-if="!item.component">
              {{ rootFilters(getValue(row, item.prop), item.filter) }}
            </div>
            <div v-else>
              <component :is="item.component" v-if="typeof item.component === 'string'" :row="row"
                :cusprop="item.cusprop" />
              <template v-else>
                <component :is="item.component[o_i]" v-for="(value, o_i) in item.component" :key="o_i" :row="row"
                  :cusprop="item.cusprop[o_i]" />
              </template>
            </div>
          </template>
        </el-table-column>
      </template>
    </el-table>

    <!--后备内容-->
    <!--具名插槽-->
    <!--作用域插槽-->
    <!-- <div v-if="hasPage && pageObj.total > 0" class="page pagination-container">
      <slot :pageObj="pageObj" name="paging">
        <el-pagination :background="true" :current-page.sync="innerSearchForm.page_num"
          :page-size.sync="innerSearchForm.page_size" layout="slot, prev, pager, next, sizes, jumper"
          :page-sizes="pageSizes" :total="pageObj.total" @size-change="sizeChangePage"
          @current-change="handleCurrentChange">
          <span class="pag-total">{{ totalTxt }}</span>
        </el-pagination>
      </slot>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "TableModel",
  props: {
    stripe: {
      type: Boolean,
      default: false,
    }, // 斑马条纹
    maxHeight: {}, // 最大高度
    headerStyle: {
      type: Object,
      default() {
        return { background: "#f6f8fa", color: "#888f8c" };
      },
    }, // 头部的样式
    hasPage: {
      type: Boolean,
      default: true,
    },
    listArray: {
      type: [Array, String],
      default: function () {
        return [];
      },
    },
    columns: {
      type: [Array, String],
      default: function () {
        return [];
      },
    },
    searchForm: {
      type: Object,
      default: function () {
        return {};
      },
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 40, 50];
      },
    },
    // 是否自动加载
    autoLoad: {
      type: Boolean,
      default: true,
    },
    // 是否为前端分页
    frontPage: {
      type: Boolean,
      default: false,
    },
    // 数据回调
    callback: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      pageObj: {
        total: 0,
        pages: 0,
      },
      innerData: [],
      innerColumn: [],
      innerSearchForm: {},
    };
  },
  watch: {
    listArray() {
       this.getList();
    },
  },
  computed: {
    totalTxt() {
      return `共${this.pageObj.total}条记录 第${this.innerSearchForm.page_num}/${this.totalPage}页`;
    },
    totalPage() {
      return (
        Math.ceil(this.pageObj.total / this.innerSearchForm.page_size) || 1
      );
    },
  },
  async created() {
    this.loading = this.autoLoad;
    this.innerSearchForm = JSON.stringify(this.searchForm || {});
    this.innerSearchForm = JSON.parse(this.innerSearchForm); // 深克隆
    this.innerColumn = this.columns;
    if (this.autoLoad) {
      this.getList({}, true);
    }
  },
  methods: {
    addFirst(row) {
      this.innerData.unshift(row);
      //this.$forceUpdate(); //强制刷新
    },
    updateList(index, newValue) {
      this.innerData.splice(index, 1, newValue);
    },
    deleteRow(id) {
      var index = this.findById(id);
      if (index >= 0) {
        this.innerData.splice(index, 1);
      }
    },
    findById(id) {
      var has = this.innerData.findIndex((row) => {
        return row.id == id;
      });

      return has;
    },
    rootFilters(val, filter) {
      const mth = this.$options.filters[filter];
      return (mth && mth(val)) || val;
    },
    getList(searchForm, loading) {
      this.loading = loading !== false;
      searchForm = searchForm || {};
      var params = { ...this.innerSearchForm, ...searchForm };
      if (this.listArray instanceof Array) {
        if (this.frontPage) {
          this.pageObj.total = this.listArray.length || 0;
          var page = this.innerSearchForm.page_num;
          var size = this.innerSearchForm.page_size;
          this.innerData = this.listArray.slice((page - 1) * size, page * size);
        } else {
          this.innerData = this.listArray;
        }
        this.loading = false;
        return;
      }
      this.innerSearchForm = params;
    },
    filterParams(params) {
      for (const key in params) {
        if (params[key] && typeof params[key] === "string") {
          params[key] = params[key].trim();
        }
        if (
          params[key] === "" ||
          params[key] === null ||
          (params[key] &&
            params[key] instanceof Array &&
            params[key].length === 0)
        ) {
          params[key] = undefined;
        }
        if (
          params[key] &&
          params[key] instanceof Array &&
          params[key].length > 0
        ) {
          params[key] = params[key].join(",");
        }
      }
      return params;
    },
    sorting({ column }) {
      const order = column.order;
      const sort = column.sortable;
      if (order === "ascending") {
        // 正序 console.log('↑日期由远到近')
        this.innerSearchForm.sort = sort;
      } else if (order === "descending") {
        // 倒序 console.log('↑日期由近到远')
        this.innerSearchForm.sort = "-" + sort;
      } else {
        this.innerSearchForm.sort = undefined;
      }
      this.getList({}, true); // 刷新页面
    },
    selectionChange(selection) {
      this.$emit("selection");
    },
    sizeChangePage(obj) {
      this.innerSearchForm.page_size = obj;
      this.getList({}, true); // 刷新页面
    },
    handleCurrentChange(obj) {
      this.innerSearchForm.page_num = obj;
      this.getList({}, true); // 刷新页面
    },
    getValue(row, prop) {
      if (!prop) return "-";
      if (prop.indexOf(".") > -1) {
        return this.$jsonPath(row, prop) ? this.$jsonPath(row, prop) : "-";
      }
      if (row[prop] === "" || row[prop] === null || row[prop] === undefined) {
        return "-";
      }
      return row[prop];
    },
  },
};
</script>
<style lang="scss">
.yz-table {
  .el-table {
    .el-table__body {
      width: 100% !important;
    }
  }
}
</style>
